import { domainConfig } from "../config.js";

const normalizeBaseUrl = (value) => String(value || "").replace(/\/+$/, "");

export const getEventShareUrls = (dataTable) => {
  const token = String(dataTable?.token || "").trim();
  if (!token) {
    return {
      networking: "",
      credentialLogin: "",
      credentialRegistration: "",
    };
  }

  const encodedToken = encodeURIComponent(token);
  const networkingBase = normalizeBaseUrl(domainConfig.eventos);
  const credentialBase = normalizeBaseUrl(domainConfig.credenciamento);
  const accessCode = encodeURIComponent(String(dataTable?.codigo_credenciamento || ""));

  return {
    networking: networkingBase ? `${networkingBase}/?token=${encodedToken}` : "",
    credentialLogin: credentialBase
      ? `${credentialBase}/login?token=${encodedToken}&access_code=${accessCode}`
      : "",
    credentialRegistration: credentialBase
      ? `${credentialBase}/registro?token=${encodedToken}`
      : "",
  };
};

export const getPlatform1ShareUrls = (dataTable) => {
  const token = String(dataTable?.token || "").trim();
  const applicationsBase = normalizeBaseUrl(domainConfig.aplicativos);
  if (!token || !applicationsBase) {
    return { participant: "", presenter: "" };
  }

  const eventUrl = `${applicationsBase}/?token=${encodeURIComponent(token)}`;
  const presenterCode = String(dataTable?.codigo_presenter || "").trim();

  return {
    participant: eventUrl,
    presenter: presenterCode
      ? `${eventUrl}&presenter=${encodeURIComponent(presenterCode)}`
      : "",
  };
};
